import Logo from "../../assets/images/logo.png";
import {Avatar} from "antd";
import {FaFacebook, FaTelegram} from "react-icons/fa";
import {FaInstagram} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footers = () => {
  return (
    <>
      <Link to="/">
        <Avatar size={70} src={Logo} />
      </Link>
      <div
        style={{
          minWidth: 200,
          margin: "15px 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <a href="https://t.me/shortime0">
          <FaTelegram size={35} style={{color: "#229ED9"}} />
        </a>
        <a href="https://www.instagram.com/boburjon_02">
          <FaInstagram size={35} style={{color: "#C13584"}} />
        </a>
        <a href="https://www.facebook.com/boburjon.jorayev.71">
          <FaFacebook size={35} style={{color: "#3a589b"}} />
        </a>
      </div>
      Monaliza ©{new Date().getFullYear()} Created by <a href="https://boburjon.uz/">Boburjon</a>
    </>
  );
};

export default Footers;
